import React, { useState } from 'react';
import { Intent, Classes ,H3} from "@blueprintjs/core";
import { Button, Card, Elevation,Slider, Overlay } from "@blueprintjs/core";
import CardEditorForTeacher from "./CardEditorForTeacher.tsx";
import CardViewerAudio from './CardViewerAudio.tsx';
import CardObject from "./CardObject.tsx";
import CardImage from './CardImage.tsx';
import {CardPdf} from './CardPdf.tsx'
import CardDocumentWeb from './CardDocumentWeb.tsx';

export default class CardMesEnregistrements extends React.Component  <{}> {
    state = {
        aideenregistrementaudio:false,
        deleterecord:-1,
        mustRefresh:false,
    }
    componentDidMount () {console.log(this.props.recordingsbydate); }
    componentDidUpdate(prevProps: Readonly<{}>, prevState: Readonly<{}>, snapshot?: any): void {
        
    }
setAideenregistrementaudio=(ev)=>{this.setState({aideenregistrementaudio:ev})}
setDeleterecord=(ev)=>{this.setState({deleterecord:ev})}
renderItemRecordDetails=(item)=>
{
    return(
    item.visible?<ul style={{ listStyle: "none", padding: 0 }}>
    <li style={{backgroundColor: '#aae1ff',padding: 10,borderRadius: 10,boxShadow: '2px 2px 8px #aaa'}}>
      <div><div style={{fontSize:9}}> {item.date}</div><div>{item.title}</div></div>{item.type=="audio"?<audio src={item.data} controls />:null}<Button style={{margin:'-45px 0 0 20px'}} onClick={(ev)=>this.setState({deleterecord:item.id})} icon="trash"></Button>
    </li>
    </ul>:null)
}
handletaille=()=>{}
renderStudentDocument = (item) => {
    if (item.type=="")item.type="object";
    if (item.type=="audio")return(<CardViewerAudio id_document={item.id} url_video={item.data}/>)
    if (item.type=="text")return (<div style={{backgroundColor:'#fff',padding: 5,margin: 5, borderRadius:5}}><div style={{borderRadius:5,backgroundColor: '#fff2e5', padding: '4px 6px', marginBottom: 5,width: 'fit-content'}}>Document travaillé : {item.title}</div>
        <CardEditorForTeacher _onUploadtext={this.props._onUploadtext} handletaille={this.handletaille} userid={this.props.userid} recordingsbydate={this.props.recordingsbydate} matiere_id={item.id_matiere} id_document={item.id_document} title_document={item.title}/></div>)
    if (item.type=="object") return(<div style={{backgroundColor:'#fff',padding: 5,margin: 5, borderRadius:5}}><div style={{borderRadius:5,backgroundColor: '#fff2e5', padding: '4px 6px', marginBottom: 5,width: 'fit-content'}}>Document travaillé : {item.title}</div>
    <CardObject id_document={item.ID}url_video={item.data} objectif={item.objectif} title_document={item.title} description={item.description}/></div>)
    if (item.type =="pdf" ) {
        return ( <div style={{backgroundColor:'#fff',padding: 5,margin: 5, borderRadius:5}}><div style={{borderRadius:5,backgroundColor: '#fff2e5', padding: '4px 6px', marginBottom: 5,width: 'fit-content'}}>Document travaillé : {item.title}</div>
          <CardPdf   id_document={item.ID}url_video={item.data} objectif={item.objectif} title_document={item.title} description={item.description}/></div>
        );
    }
    if (item.type =="web" ) {
        return (  
            <div style={{backgroundColor:'#fff',padding: 5,margin: 5, borderRadius:5}}><div style={{borderRadius:5,backgroundColor: '#fff2e5', padding: '4px 6px', marginBottom: 5,width: 'fit-content'}}>Document travaillé : {item.title}</div>
          <CardDocumentWeb  id_document={item.ID}url_video={item.data} objectif={item.objectif} title_document={item.title} description={item.description}/></div>
        );
    }
    if (item.type=="image") {
        return (
            <div style={{backgroundColor:'#fff',padding: 5,margin: 5, borderRadius:5}}><div style={{borderRadius:5,backgroundColor: '#fff2e5', padding: '4px 6px', marginBottom: 5,width: 'fit-content'}}>Document travaillé : {item.title}</div>
            <CardImage    id_document={item.ID}url_video={item.data} objectif={item.objectif} title_document={item.title} description={item.description}/></div>
        );
    }
    return(null)
    
}
renderItemRecordDetails2=(item)=>
{
    return(
    item.visible?<ul style={{ listStyle: "none", padding: 0 }}>
    <li style={{backgroundColor: '#aae1ff',padding: 10,borderRadius: 10,boxShadow: '2px 2px 8px #aaa'}}>
      <div><div style={{borderRadius:5,backgroundColor: '#fff2e5', padding: '4px 6px', marginBottom: 5,width: 'fit-content'}}>{item.nom_etudiant}</div><div style={{fontSize:9}}> {item.date}</div><div>{item.type=="audio"?<Button onClick={()=>this.downloadAs(item.data,item.nom_etudiant+"_"+item.date)} icon="cloud-download">Télécharger</Button>:null}<Button style={{margin:'0 4px'}} onClick={(ev)=>this.setState({deleterecord:item.id})} icon="trash"></Button></div></div>
      {this.renderStudentDocument(item)}
    </li>
    </ul>:null)
}
renderItemRecord=(itemr)=>
{
  return (itemr.visible?<div style={{padding:3}}><Button style={{marginRight:10}} icon={itemr.selected?"minus":"plus"} onClick={(ev)=>{itemr.selected=!itemr.selected;this.setState ({mustRefresh:!this.state.mustRefresh});}}/><span>{itemr.datedujour}</span><div>{itemr.selected ==true ?itemr.recordings.map(p => this.renderItemRecordDetails2(p)):null} </div></div>:null)
}
render() {
const {isnotlabo,matiereencours,recordings,EffacerEnregistrement,recordingsbydate,userid}=this.props;
const {aideenregistrementaudio,deleterecord}=this.state;
const {setAideenregistrementaudio,setDeleterecord,renderItemRecord}=this;
return(

<div style={{minWidth:700,width: 'calc( 100% - 280px)',display:isnotlabo,boxShadow:' 0 0 0 1px rgb(16 22 26 / 10%), 0 1px 1px rgb(16 22 26 / 20%), 0 2px 6px rgb(16 22 26 / 20%)', padding: 20,margin: 5,backgroundColor: '#fff'}}>
      <h3><a href="" onClick={(ev)=>{ev.preventDefault();setAideenregistrementaudio(true)}}>Mes enregistrements dans {matiereencours}</a></h3>
      <Overlay isOpen={aideenregistrementaudio} className={Classes.OVERLAY_SCROLL_CONTAINER} >
          <div style={{ color: '#444', background: '#fff', padding: '30px 50px 20px', width: '50%',margin: '120px 25%'}}>
                        <H3>Mes enregistrements audio</H3>
                        <p>
                           Retrouvez ici tous les enregistrements que vous avez effectué.
                        </p>
                        <p>
                           Selectionnez d'abord une matière pour pouvoir enregistrer.
                            Vous pouvez enregistrer votre voix à l'aide des boutons dans la barre de menu du haut. (voir image ci-dessous)
                        </p>
                        <div>
                        <img src="recorder.jpg" /> 
                        </div>
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{ev.preventDefault();setAideenregistrementaudio(false)}} style={{ margin: "" }}>
                                Fermer
                            </Button>
                            
                            
                        </div>
                    </div>
      </Overlay>
      <Overlay isOpen={deleterecord>-1} className={Classes.OVERLAY_SCROLL_CONTAINER} >
                    <div style={{ color: '#444', background: '#fff', padding: '30px 50px 20px', width: '50%',margin: '120px 25%'}}>
                        <H3>Effacer un enregistrements audio</H3>
                       
                        <p>
                            Êtes-vous sur de vouloir effacer votre enregistrement?
                        </p>
                        <p>
                          Détails: enregistrement du <span icon="date"><b>{recordings.map((item)=>{if(item.id==deleterecord) return item.date})}</b></span>
                        </p>
                        <p></p>
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{ev.preventDefault();setDeleterecord(-1);}} style={{ margin: "" }}>
                                Annuler
                            </Button>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();setDeleterecord(-1);EffacerEnregistrement(deleterecord);}} style={{ margin: "" }}>
                                Effacer
                            </Button>
                            
                            
                        </div>
                    </div>
      </Overlay>
        <div>
        {recordingsbydate.map(p => renderItemRecord(p))}
        </div>
      </div>
    )}

}